import ReactDOM from 'react-dom';
import { ReactNode } from 'react';
import { AllieFabButton } from '../Fab/FabButton';
import { AllieAddIcon } from '../../styling/icons';

export const useFabToolbar = () => {
  const init = (onClickFab: () => void, disabled: boolean = false, icon?: ReactNode) => {
    const ionFabElement = document.getElementById('allie-fab-toolbar');
    if (ionFabElement) {
      ReactDOM.render(
        <AllieFabButton disabled={disabled} onClick={onClickFab}>
          {icon ?  icon : <AllieAddIcon />}
        </AllieFabButton>,
        ionFabElement,
      );
    }
  };

  return { init };
};